import { Box, Typography } from "@mui/material"
import React, { useEffect, useState, useMemo } from "react"
import StatusBadge from "../../../../components/StatusBadge"
import MotorStatusCadastroService from "src/services/motor-status-cadastro-service"

const ResumoConsolidadoStatus = () => {
    const [rows, setRows] = useState([])
    const statusService = useMemo(() => new MotorStatusCadastroService(), [])

    useEffect(() => {
        loadContadores()
    }, [])

    const loadContadores = async () => {
        try {
            const payload = await statusService.loadContadoresCadastro()

            const formatted = [
                { id: 1, categoria: "Características", ...payload.body?.Caracteristicas },
                { id: 2, categoria: "Eventos", ...payload.body?.Eventos },
            ]

            setRows(formatted)
        } catch (error) {
            console.error("Erro ao carregar contadores:", error)
        }
    }

    const renderItem = (value, label, color) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <StatusBadge
                label={`${value}`}
                width={100}
                radius={1}
                backgroundColor={color}
                fontColor="common.white"
            />
            <Typography variant="body2" color="common.white">
                {label}
            </Typography>
        </Box>
    )

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {rows.map((row) => (
                <Box key={row.id} sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                    <Typography sx={{ minWidth: 140, fontWeight: 500 }} color="common.white">
                        {row.categoria}
                    </Typography>
                    {renderItem(row.EmAndamento, "Em andamento", "warning.main")}
                    {renderItem(row.EmProducao, "Em produção", "#2BCE95")}
                    {renderItem(row.Excluidos, "Excluídos", "error.main")}
                    {renderItem(row.Total, "Total", "grey.700")}
                </Box>
            ))}
        </Box>
    )
}

export default ResumoConsolidadoStatus